import type { QueryClient } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export function invalidatePricelistCaseFileQueries(queryClient: QueryClient) {
  void queryClient.invalidateQueries({
    queryKey: orpc.inventoryManagement.pricelistCases.get.key(),
  });
  void queryClient.invalidateQueries({
    queryKey: orpc.inventoryManagement.pricelistCases.timeline.key(),
  });
  void queryClient.invalidateQueries({
    queryKey: orpc.inventoryManagement.pricelist.listAll.key(),
  });
}

export function clearDeletedPricelistCaseFile(
  queryClient: QueryClient,
  pdfDocumentId: string | undefined,
) {
  if (pdfDocumentId !== undefined) {
    queryClient.removeQueries({
      queryKey: orpc.inventoryManagement.pricelist.get.key({
        input: { pdfDocumentId },
      }),
    });
  }
  invalidatePricelistCaseFileQueries(queryClient);
}
